import type { StoreApi } from 'zustand'
import type { SendRawOptions } from './connectionStore'
import type { ChatState } from './chatStore'

export interface InactivityNotice {
  conversationId: string
  pausedAt: number
  resumeContent: string
  /**
   * O `clientRequestId` do turno que foi pausado. "Retomar" reenvia COM ESTE id:
   * o motor só deduplica pelo mesmo id, e um id novo reservaria material de novo.
   * Ausente só em aviso gravado no disco por versão antiga.
   */
  resumeClientRequestId?: string
  resumeOptions?: Omit<SendRawOptions, 'confirmationToken'>
}

export function inactivityNoticeForDisk(notice: InactivityNotice | null): InactivityNotice | null {
  if (!notice?.resumeOptions?.inlineAttachments) return notice
  const resumeOptions = { ...notice.resumeOptions }
  delete resumeOptions.inlineAttachments
  return { ...notice, resumeOptions }
}

export function resumeAfterInactivity(
  get: StoreApi<ChatState>['getState'],
  set: StoreApi<ChatState>['setState'],
): void {
  const { inactivityNotice: notice, inactivityResuming } = get()
  if (!notice || inactivityResuming) return
  set({ inactivityResuming: true })
  void import('./connectionStore')
    .then(({ useConnectionStore }) => {
      const started = useConnectionStore
        .getState()
        .sendRaw(
          notice.conversationId,
          notice.resumeContent,
          notice.resumeClientRequestId ?? crypto.randomUUID(),
          notice.resumeOptions,
          // Replay explícito do MESMO id: sem isto a guarda local de duplicata
          // (id enviado na última hora) descartaria a retomada.
          notice.resumeClientRequestId !== undefined,
        )
      set(
        started
          ? { inactivityNotice: null, inactivityResuming: false }
          : { inactivityResuming: false },
      )
    })
    .catch(() => set({ inactivityResuming: false }))
}
